var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.btnChecked !== "b2b",
          expression: "btnChecked!=='b2b'",
        },
        {
          name: "model",
          rawName: "v-model",
          value: _vm.addressData.gender,
          expression: "addressData.gender",
        },
      ],
      staticClass: "custom-select test",
      attrs: { disabled: _vm.isCompany, "data-autofocus": "" },
      on: {
        change: [
          function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.$set(
              _vm.addressData,
              "gender",
              $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            )
          },
          function ($event) {
            return _vm.emitInputEvent($event.target.value)
          },
        ],
      },
    },
    _vm._l(_vm.currentSalutation, function (salutation, index) {
      return (!_vm.isCompany && salutation.key !== "company") ||
        (_vm.isCompany && salutation.key === "company")
        ? _c(
            "option",
            {
              key: index,
              domProps: {
                value: salutation.key,
                selected:
                  _vm.addressData.gender === salutation.key &&
                  _vm.checkGenderCompany(salutation.key),
              },
            },
            [_vm._v("\n        " + _vm._s(salutation.name) + "\n    ")]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }